import { render, staticRenderFns } from "./BaseSort.vue?vue&type=template&id=0956b779&"
import script from "./BaseSort.vue?vue&type=script&lang=js&"
export * from "./BaseSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports